<!--
 * @Description: 
 * @Version: 1.0
 * @Autor: laikt
 * @Date: 2020-11-11 10:28:48
 * @LastEditors: laikt
 * @LastEditTime: 2020-11-26 16:46:35
-->
<template>
  <div class="replay">
    <el-tabs
      :value="activeName"
      @tab-click="handleClick"
      :before-leave="beforeLeave"
    >
      <el-tab-pane label="同步回放" name="first">
        <div class="sync">
          <label class="sync_label">开始时间：</label>
          <div class="sync_content">
            <el-time-picker
              class="special"
              v-model="syncTime"
              value-format="timestamp"
              placeholder="开始时间"
              popper-class="special"
              :clearable="false"
              @change="changeTime"
            ></el-time-picker>
            <div>
              <el-button
                type="primary"
                size="small"
                :loading="syncIsDisabled"
                :disabled="syncIsDisabled"
                @click="syncHandler"
              >
                {{ videoMapStatus == 0 ? "同步播放" : "停止播放" }}
              </el-button>
            </div>
          </div>
        </div>
      </el-tab-pane>
      <el-tab-pane label="异步回放" name="second">
        <div class="async">
          <div class="async_box">
            <div
              class="async_list"
              v-for="(camera, index) in cameraList"
              :key="camera.id"
            >
              <label class="async_label" :title="camera.label">
                {{ camera.label }}
              </label>
              <div class="async_content time-line-wrapper">
                <lo-slider-time
                  ref="sliderTime"
                  class="time-line"
                  :show-tooltip="true"
                  :format-tooltip="formatTooltip"
                  :timeRange="0"
                  v-model="camera.time"
                  @change="sliderChange($event, camera, index)"
                ></lo-slider-time>
              </div>
            </div>
          </div>

          <div class="async_list">
            <label class="async_label"></label>
            <div
              class="async_content time-line-wrapper"
              style="margin-top: 10px;height: 40px;"
            >
              <div class="el-slider__footer">
                <div
                  class="time-item"
                  v-for="(item, index) of 24"
                  :key="item + '-' + index"
                  :style="{ width: 100 / 24 + '%' }"
                >
                  {{ formatTime(index) }}
                </div>
              </div>
            </div>
          </div>
          <el-button
            class="async_auto"
            type="primary"
            size="small"
            @click="syncHandler"
            :loading="syncIsDisabled"
            :disabled="syncIsDisabled"
          >
            {{ videoMapStatus == 0 ? "异步播放" : "停止播放" }}
          </el-button>
        </div>
      </el-tab-pane>
    </el-tabs>
  </div>
</template>
<script>
import LoSliderTime from "@/components/video/LoSliderTime";
import moment from "moment";

export default {
  name: "replay",
  components: {
    LoSliderTime
  },
  props: {
    checkedNode: {
      type: Object,
      default: () => {}
    },
    time: String,
    cameraList: {
      type: Array,
      default: () => []
    },
    videoMapStatus: {
      type: Number,
      default: 0
    },
    syncIsDisabled: {
      type: Boolean,
      default: false
    },
    timeList: {
      type: Array,
      default: () => []
    }
  },
  data() {
    return {
      activeName: "first",
      syncTime: "",
      startTime: "",
      currentAllLineVideos: [],
      timeLineRange: [25200000, 43200000] // 时间轴范围
    };
  },
  created() {
    this.syncTime = moment(this.time)
      .startOf("dya")
      .valueOf();
  },
  methods: {
    // 格式化提示时间
    formatTooltip(value) {
      let time = moment()
        .startOf("days")
        .valueOf();

      return moment(time + value).format("HH:mm:ss");
    },
    changeTime(val) {
      let time = moment(val).format("HH:mm:ss");
      let data = `${this.time} ${time}`;
      this.startTime = moment(data).valueOf();
      console.log(val, time);
    },
    // 设置每个时间块的样式
    tempItemStyle(data) {
      let max = 86400000;
      let today = this.searchData;
      let bTime = moment(data.beginTime).valueOf();
      let eTime = moment(data.endTime).valueOf();
      return {
        left: ((bTime - today) / max) * 100 + "%",
        width: ((eTime - bTime) / max) * 100 + "%"
      };
    },
    formatTime(value) {
      return value < 10 ? `0${value}: 00` : ` ${value}: 00 `;
    },
    beforeLeave() {
      console.log("beforeLeave", this.videoMapStatus);

      if (this.videoMapStatus === 0) {
        return true;
      } else {
        return false;
      }
    },
    handleClick(tab, event) {
      console.log(tab, event, this.videoMapStatus);
      if (this.videoMapStatus === 0) {
        this.activeName = tab.name;
      } else {
        this.$confirm(
          `您正在选择${
            this.activeName === "first" ? "异步回放" : "同步回放"
          }，如确定将停止${
            this.activeName !== "first" ? "异步回放" : "同步回放"
          }?`,
          "提示",
          {
            confirmButtonText: "确定",
            cancelButtonText: "取消",
            type: "warning"
          }
        )
          .then(() => {
            // this.$message({
            //   type: "success",
            //   message: "提交成功"
            // });
            this.activeName = tab.name;
            this.$emit("tabHandle");
          })
          .catch(() => {
            this.$message({
              type: "info",
              message: "已取消"
            });
          });
      }
    },
    sliderChange(value, camera, index) {
      this.$emit("sliderChange", value, camera, index);
    },
    syncHandler() {
      this.$emit(
        "queryVideo",
        this.activeName === "first" && this.startTime == ""
          ? this.syncTime
          : this.startTime
      );
    }
  }
};
</script>
<style lang="scss" scoped>
$normalfont: #9297a6;
$sidebarwidth: 240px;
$lightfont: #46bfea;
.replay {
  /deep/.el-tabs__header {
    border: 0;
    padding: 0 16px;
    background-color: #0f2e5a;
  }
  /deep/.el-tabs__nav.is-top {
    width: 100%;
    display: flex;
    .el-tabs__item {
      height: 40px;
      border: 0;
      box-sizing: border-box;
      margin: 0;
      color: #46bfea;
      font-weight: normal;
      display: flex;
      align-items: center;
      justify-content: center;
    }
    .el-tabs__item.is-active {
      // border-top: 2px solid #46bfea;
      //   background-color: #091e4a;
      margin: 0;
      position: relative;
    }
  }
  .sync {
    padding: 0 16px;
    display: flex;
    &_label {
      font-size: 16px;
      display: flex;
      align-items: flex-start;
    }
    .sync_content {
      display: inline-block;
    }
    .special {
      background-color: transparent;
      margin-bottom: 16px;
      /deep/ .el-input__inner {
        color: $normalfont;
        border-color: #46bfea;
        background-color: rgba(70, 191, 234, 0.2);
      }
      /deep/ .el-input__suffix {
        color: $normalfont;
      }
    }
  }
  .time-line-wrapper {
    position: relative;
    /deep/ .lo-slider-time {
      background-color: #08193b;
      /deep/ .el-slider__runway {
        background-color: #21304d;
        border-color: #2d3e64;
        border-width: 1px;
        border-radius: unset;
      }
      /deep/ .el-slider__footer {
        background-color: #08193b;
        .time-item {
          color: $normalfont;
          &::before {
            background-color: #2e3e63;
          }
        }
      }
      .el-slider__button-wrapper {
        width: 9px;
        background-color: unset;
        .tooltip {
          color: $lightfont;
        }
        .tooltip-btn {
          background-color: unset;
        }
      }
      .el-slider__bar-left,
      .el-slider__bar-right {
        background-color: transparent;
        display: none;
      }
      .tooltip-left {
        background: none;
        background-repeat: no-repeat;
        background-size: contain;
        background-color: #3facd2;
        width: 3px;
      }
      .tooltip-right {
        background: url("../../../assets/images/video/right.png");
        background-repeat: no-repeat;
        background-size: contain;
      }
    }

    .legend-wrapper {
      position: absolute;
      right: 0;
      top: -20px;
      display: flex;
      & > div {
        display: flex;
        align-items: center;
        justify-content: center;
      }
      .has-video {
        .square {
          background-color: #ffaa00;
        }
      }
      .no-video {
        margin-left: 20px;
        .square {
          border: 1px solid rgba(126, 151, 183, 0.25);
          background-color: #21304d;
          box-sizing: border-box;
        }
      }
      .square {
        height: 12px;
        width: 12px;
        margin-right: 5px;
      }
    }
  }
  .async {
    padding: 0 16px;
    // padding-top: 20px;
    box-sizing: border-box;
    width: 100%;
    .async_box {
      padding-top: 20px;
      width: 100%;
      max-height: 150px;
      overflow: auto;
    }
    .async_box::-webkit-scrollbar {
      display: none; /* Chrome Safari */
    }
    .async_list {
      display: flex;
      width: 100%;
    }
    .async_list + .async_list {
      margin-top: 20px;
    }
    &_label {
      font-size: 14px;
      color: #fff;
      margin-right: 10px;
      width: 140px;
      white-space: nowrap;
      text-overflow: ellipsis;
      overflow: hidden;
      word-break: break-all;
    }
    .async_content {
      flex-grow: 1;
    }
    .async_auto {
      margin-left: 140px;
      margin-top: 14px;
    }
  }
  .el-button {
    background-color: #164271;
    color: #46bfea;
    border-color: #46bfea;
  }
  .lo-slider-time /deep/.el-slider__runway {
    height: 20px;
  }
  .el-slider.el-slider-reset {
    height: 30px !important;
  }
  .el-slider {
    height: 40px !important;
  }
  .el-slider__footer {
    position: absolute;
    display: flex;
    left: 0;
    bottom: 0;
    width: 100%;
    height: 20px;
    font-size: 12px;
    border-top: 1px solid;
    .time-item {
      position: relative;
      display: flex;
      align-items: flex-end;
      color: #606266;
      line-height: 1;
      &::before {
        content: "";
        position: absolute;
        top: -7px;
        left: 0;
        width: 1px;
        height: 6px;
        background-color: #dfe5ed;
      }
    }
  }
}
</style>
